import { graphql } from 'gatsby';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import React from 'react';

import Layout from '../components/Layout';
import Seo from '../components/Seo';

const CookiePolicyPage = (): JSX.Element => {
  const { language } = React.useContext(I18nextContext);
  const iubendaScript =
    language === 'it'
      ? `<a href="https://www.iubenda.com/privacy-policy/63814340/cookie-policy" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Cookie Policy">Cookie Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>`
      : `<a href="https://www.iubenda.com/privacy-policy/90416162/cookie-policy" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Cookie Policy">Cookie Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>`;

  return (
    <Layout user="tenant">
      <Seo
        hreflang={`${language}`}
        title="Cookie Policy"
        ogImageUrl={`${process.env.GATSBY_CDN_URL}/opengraph/zappyrent-logo-green-500x500.png`}
        ogImageHeight="500"
        ogImageWidth="500"
      />
      <article>
        <div dangerouslySetInnerHTML={{ __html: iubendaScript }} />
      </article>
    </Layout>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default CookiePolicyPage;
